import { useQuery } from '@tanstack/react-query'
import { bookKeys } from '../../../../data/queryFactories'
import {
  showErrorToast,
  showLoadingToast,
  showSuccessToast,
  toastKey,
} from '../../../../utils/showToast'
import { bookService } from '../../../../service/BookService'
import { convertUnixToDate } from '../../../../utils/conversion'
import { useParseQuery } from '../../../../hooks/useNav'
// import { useRef } from 'react'
import {
  clearLocalStorage,
  getLocalStorage,
} from '../../../../utils/localStorage'
import { BOOKS_PACKAGE_STORAGE_KEY } from '../../../../data/constants'
const clampDescription = (description) => {
  if (!description) return ''
  const words = description.split(' ')
  if (words.length > 10) {
    return words.slice(0, 10).join(' ') + '...'
  }
  return description
}
function mapBookData(data) {
  return {
    uuid: data?.uuid ?? '',
    title: data?.title ?? '',
    author: data?.author ?? '',
    publishYear: data?.publishYear ?? '',
    subject: data?.subject ?? '',
    major: data?.major ?? '',
    typename: data?.typename ?? '',
    faculty: data?.faculty ?? '',
    bookCollections: (data?.bookCollections ?? []).join(', '),
    publisher: data?.publisher ?? '',
    isbn: data?.isbn ?? '',
    // description: data?.description ?? '',
    description: clampDescription(data?.description),
    uploader: data?.uploader ?? '',
    price: data?.price ?? '',
    status: data?.status ?? '',
    // cover: data?.cover ?? '',
    // fileSize: data?.fileSize ?? '',
    // pages: data?.pages ?? '',
    // statusName: data?.statusName ?? '',
    // token: data?.token ?? '',
    // uploadDate: convertUnixToDate(data?.uploadDate),
    // canUseReadie: data?.canUseReadie ?? '',
    // bookUrl: data?.bookUrl ?? '',
  }
}
// const getCurrentUuid
export default function useGetBooks() {
  const { queryParams } = useParseQuery()

  const { data, isLoading, error } = useQuery({
    queryFn: async () => {
      try {
        showLoadingToast('Đang tải', toastKey.BOOKS_MANAGEMENT.LIST.GET)
        const pageNumber = parseInt(queryParams?.pageNumber - 1) || 0

        const { success, message } = await bookService.search({
          ...queryParams,
          pageNumber,
        })

        if (!success) {
          throw new Error(message.content)
        }

        if (!message?.content) {
          throw new Error('Không có dữ liệu trả về')
        }

        showSuccessToast(
          'Tải sách thành công',
          toastKey.BOOKS_MANAGEMENT.LIST.GET
        )
        clearLocalStorage(BOOKS_PACKAGE_STORAGE_KEY.BOOK_PACKAGE_UUID)

        return {
          totalResult: message.content.totalResult,
          totalPages: message.content.totalPages,
          currentPage: message.content.currentPage,
          books: (message?.content?.pageItems ?? []).map((item) =>
            mapBookData(item)
          ),
        }
      } catch (error) {
        throw new Error(error.message)
      }
    },
    queryKey: bookKeys.list({
      ...queryParams,
    }),
  })

  if (error) {
    showErrorToast({
      error: error.message,
      message: 'Lấy thông tin thất bại',
      toastId: toastKey.BOOKS_MANAGEMENT.LIST.GET,
    })
  }

  return { data, isLoading }
}
